import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  AppBar,
  Button,
  Chip,
  Dialog,
  DialogContent,
  Tab,
  Tabs,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Paper,
  Container,
} from '@material-ui/core';
import AdjustIcon from '@material-ui/icons/Adjust';
import {
  LocalGroceryStore,
  Business,
  ShoppingCart,
  Payment,
  AccountBalance,
  Edit,
  CloudUpload,
  AttachMoney,
  ListAltOutlined
} from '@material-ui/icons';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { toast } from "react-toastify";
import * as XLSX from 'xlsx';

// Redux actions
import { addProduit, deleteProduit, updateProduit } from '../../redux/actions/produitActions';
import { getDepenses } from '../../redux/actions/depenseActions';

// Services
import CliniqueService from '../../services/CliniqueService';
import ProduitService from '../../services/ProduitService';
import FondService from '../../services/FondService';

// Components
import CustomizedDialogs from '../../components/dialog';
import ProduitVendu from '../../components/ProduitVendu';
import RegistrationForm from '../../components';
import VendreProduits from '../../components/VendreProduits';
import MaterialTable from 'material-table';
import GestionStock from '../../components/GestionStock';
import StatsModePaiement from '../../components/StatModePayement';
import GestionDepenses from '../../components/GestionDepenses.js';
import AjusterStockDialog from '../../components/AjusterStockDialog.js';

// Styles identiques au composant Clients
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    paddingTop: theme.spacing(1),
  },
  appBar: {
    background: 'linear-gradient(135deg, #226D68 0%, #1a524e 100%)',
    borderRadius: '12px 12px 0 0',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%',
  },
  tabs: {
    '& .MuiTab-root': {
      minWidth: 120,
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'none',
      color: theme.palette.common.white,
      opacity: 0.8,
      '&.Mui-selected': {
        opacity: 1,
        color: theme.palette.common.white,
      },
      '&:hover': {
        opacity: 1,
        backgroundColor: 'rgba(242, 101, 34, 0.1)',
      },
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#f26522',
      height: 3,
    },
  },
  statCard: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '16px',
    padding: theme.spacing(3),
    textAlign: 'center',
    transition: 'all 0.3s ease',
    border: `1px solid ${theme.palette.divider}`,
    position: 'relative',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 40px rgba(34, 109, 104, 0.15)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #226D68 0%, #f26522 100%)',
    },
  },
  tabContainer: {
    padding: theme.spacing(4),
    backgroundColor: 'white',
    borderRadius: '0 0 16px 16px',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.08)',
    minHeight: '500px',
    border: `1px solid #e0e0e0`,
    borderTop: 'none',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%',
  },
  iconWrapper: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
    background: 'linear-gradient(135deg, #226D68 0%, #2a857e 100%)',
  },
  chip: {
    borderRadius: '20px',
    fontWeight: 600,
    margin: theme.spacing(0.5),
    fontSize: '0.75rem',
  },
  title: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(2), 
    marginTop: theme.spacing(1), 
    fontSize: '2rem', 
  },
  subtitle: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontWeight: 500,
    fontSize: '1.1rem',
  },
  statNumber: {
    fontWeight: 700,
    color: '#226D68',
    fontSize: '2.5rem',
  },
  statLabel: {
    color: '#666',
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    letterSpacing: '1px',
  },
  accentText: {
    color: '#f26522',
    fontWeight: 600,
  },
  statsContainer: {
    marginTop: theme.spacing(3),
  },
  pageContainer: {
    minHeight: '100vh',
    paddingTop: theme.spacing(1), 
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    background: 'white',
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  fileInput: {
    display: 'none',
  },
  fileUploadButton: {
    background: 'linear-gradient(135deg, #f26522 0%, #ff8c42 100%)',
    color: 'white',
    fontWeight: 600,
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    '&:hover': {
      background: 'linear-gradient(135deg, #e55a1a 0%, #f57c32 100%)',
    },
  },
  statChip: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    fontWeight: 600,
    fontSize: '0.9rem',
    padding: theme.spacing(1, 2),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 200,
  },
  dialogContent: {
    padding: theme.spacing(3),
  },
  formField: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '&:hover fieldset': {
        borderColor: '#226D68',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#226D68',
      },
    },
  },
  editDialog: {
    '& .MuiDialog-paper': {
      borderRadius: 16,
      maxWidth: 800,
      width: '95%',
    }
  },
}));

// Styles pour les tabs comme dans Clients
const StyledTabs = withStyles({
  indicator: {
    backgroundColor: '#f26522',
    height: 3,
    borderRadius: 2,
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    marginRight: theme.spacing(1),
    color: 'rgba(255, 255, 255, 0.7)',
    '&$selected': {
      color: '#fff',
    },
    '&:focus': {
      opacity: 1,
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const TabContainer = ({ children, value, index, ...other }) => {
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={classes.tabContainer}
      {...other}
    >
      {value === index && children}
    </div>
  );
};

const EXTENSIONS = ['xlsx', 'xls', 'csv'];

const Produits = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const depenses = useSelector((state) => state.depenses);

  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [prod, setProd] = useState([]);
  const [depensesJour, setDepensesJour] = useState(0);
  const [depensesMois, setDepensesMois] = useState(0);
  const [depensesAnnee, setDepensesAnnee] = useState(0);
  const [stats, setStats] = useState({
    totalProducts: 0,
    lowStock: 0,
    expiredSoon: 0
  });
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);


  const [ajustementDialogOpen, setAjustementDialogOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const user = useSelector((state) => state.auth);
  const userRole = user?.rol;

  const handleAjusterOpen = (product) => {
    setSelectedProduct(product);
    setAjustementDialogOpen(true);
  };

  const handleAjusterClose = () => {
    setAjustementDialogOpen(false);
    setSelectedProduct(null);
  };

  const handleAjusterSuccess = () => {
    refreshProduits(); 
  };

  // Configuration des tabs avec le même style que Clients
// Configuration par rôle
const adminTabs = [
  { 
    label: "Caisse", 
    icon: <LocalGroceryStore />, 
    visible: true, 
    component: <VendreProduits /> 
  },
  { 
    label: "Produits", 
    icon: <Business />, 
    visible: true, 
    component: null 
  },
  { 
    label: "Produits vendus", 
    icon: <ShoppingCart />, 
    visible: true, 
    component: <ProduitVendu /> 
  },
  { 
    label: "Dépenses", 
    icon: <Payment />, 
    visible: true, 
    component: <GestionDepenses /> 
  },
  { 
    label: "Gestion stock", 
    icon: <AccountBalance />, 
    visible: true, 
    component: <GestionStock /> 
  },
  { 
    label: "Bilan paiement", 
    icon: <Payment />,
    visible: true, 
    component: <StatsModePaiement /> 
  },
];

const userTabs = [
  { 
    label: "Caisse", 
    icon: <LocalGroceryStore />, 
    visible: true, 
    component: <VendreProduits /> 
  },
  { 
    label: "Produits", 
    icon: <Business />, 
    visible: true, 
    component: null 
  },
  { 
    label: "Produits vendus", 
    icon: <ShoppingCart />, 
    visible: true, 
    component: <ProduitVendu /> 
  },
  { 
    label: "Dépenses", 
    icon: <Payment />, 
    visible: true, 
    component: <GestionDepenses /> 
  },
  { 
    label: "Bilan paiement", 
    icon: <Payment />,
    visible: true, 
    component: <StatsModePaiement /> 
  },
];

const comptaTabs = [
  { 
    label: "Produits vendus", 
    icon: <ShoppingCart />, 
    visible: true, 
    component: <ProduitVendu /> 
  },
  { 
    label: "Dépenses", 
    icon: <Payment />, 
    visible: true, 
    component: <GestionDepenses /> 
  },
  { 
    label: "Bilan paiement", 
    icon: <Payment />,
    visible: true, 
    component: <StatsModePaiement /> 
  },
];

// Sélection de la configuration selon le rôle
const tabsConfig = userRole === 'admin' ? adminTabs : 
                   userRole === 'compta' ? comptaTabs : 
                   userTabs;

  const visibleTabs = tabsConfig.filter(tab => tab.visible);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) refreshProduits();
  };

  const handleEditOpen = (product) => {
    setEditingProduct(product);
    setEditDialogOpen(true);
  };

  const handleEditClose = () => {
    setEditDialogOpen(false);
    setEditingProduct(null);
  };

  const handleProductUpdate = async () => {
    try {
      await refreshProduits();
      toast.success("Produit modifié avec succès", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      handleEditClose();
    } catch (error) {
      toast.error("Erreur lors de la modification", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  // Fonctions pour l'import Excel
  const getExention = (file) => {
    const parts = file.name.split('.');
    const extension = parts[parts.length - 1];
    return EXTENSIONS.includes(extension);
  };

  const importExcel = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!getExention(file)) {
      toast.error("Format de fichier invalide. Sélectionnez un fichier Excel ou CSV.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const bstr = event.target.result;
        const workBook = XLSX.read(bstr, { 
          type: "binary", 
          cellDates: true, 
          cellNF: false, 
          encoding: 'utf8' 
        });

        const workSheetName = workBook.SheetNames[0];
        const workSheet = workBook.Sheets[workSheetName];
        const fileData = XLSX.utils.sheet_to_json(workSheet, { 
          header: 1, 
          raw: false, 
          date_format: 'dd/mm/yyyy' 
        });

        const headers = fileData[0];
        fileData.splice(0, 1);

        const rows = fileData.map(row => {
          let rowData = {};
          row.forEach((element, index) => {
            rowData[headers[index]] = element;
          });
          return rowData;
        });

        await ProduitService.importData(auth.nom, { "rows": rows });
        toast.success("Importation réussie", {
          position: toast.POSITION.TOP_RIGHT,
        });
        refreshProduits();
      } catch (error) {
        toast.error("Erreur lors de l'importation", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };

    reader.readAsBinaryString(file);
  };

  // Fonctions de rafraîchissement
  const refreshProduits = async () => {
    try {
      const response = await CliniqueService.getAllProduits();
      setProd(response.data);
      
      // Calcul des statistiques
      const totalProducts = response.data.length;
      const lowStock = response.data.filter(p => p.qtEntrer < 10).length;
      const expiredSoon = response.data.filter(p => {
        const expiration = new Date(p.dateExpiration);
        const today = new Date();
        const diffTime = expiration.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays <= 30 && diffDays > 0;
      }).length;

      setStats({
        totalProducts,
        lowStock,
        expiredSoon
      });
    } catch (error) {
      console.error('Erreur lors du rafraîchissement des produits:', error);
    }
  };

  const refreshDepenses = () => {
    dispatch(getDepenses());
    fetchDepenseData();
  };

  const fetchDepenseData = async () => {
    try {
      const [jourResponse, moisResponse, anneeResponse] = await Promise.all([
        FondService.depensesJournee(),
        FondService.depensesMonth(),
        FondService.depensesYear()
      ]);

      setDepensesJour(jourResponse.data[0]?.val || 0);
      setDepensesMois(moisResponse.data[0]?.val || 0);
      setDepensesAnnee(anneeResponse.data[0]?.val || 0);
    } catch (error) {
      console.error('Erreur lors du chargement des dépenses:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const produits = await CliniqueService.getAllProduits();
        setProd(produits.data);
        
        // Calcul des statistiques initiales
        const totalProducts = produits.data.length;
        const lowStock = produits.data.filter(p => p.qtEntrer < 10).length;
        const expiredSoon = produits.data.filter(p => {
          const expiration = new Date(p.dateExpiration);
          const today = new Date();
          const diffTime = expiration.getTime() - today.getTime();
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          return diffDays <= 30 && diffDays > 0;
        }).length;

        setStats({
          totalProducts,
          lowStock,
          expiredSoon
        });
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    refreshDepenses();
  }, []);

  // Configuration des colonnes
  const produitColumns = [
    { title: "NOM", field: "nomProd", filterPlaceholder: "Filtrer" },
    { title: "PRIX", field: "prixProd", align: "center" },
    {
      title: "STATUT", field: "statut_produit", editable: 'never',
      render: (rowData) => (
        <Chip
          label={rowData.statut_produit}
          style={{
            background: 
              rowData.statut_produit === "NORMAL" ? "#4caf50" :
              rowData.statut_produit === "EXPIRE_BIENTOT" ? "#ff9800" : "#f44336",
            color: "white",
            fontWeight: 600
          }}
          size="small"
        />
      ),
      searchable: false, export: false
    },
    { title: "EXPIRATION", field: "dateExpiration", filterPlaceholder: "Filtrer", type: "date" },
    { title: "ENREGISTRE", field: "dateEng", filterPlaceholder: "Filtrer", type: "date", editable: 'never' },
    { title: "QUANTITE", field: "qtEntrer", filterPlaceholder: "Filtrer" },
    // { title: "STOCK", field: "stock", filterPlaceholder: "Filtrer",editable: 'never'},

  ];

  // Fonctions de rendu des tabs
  const renderProduitsTab = () => {
    return (
      <>
        <Box className={classes.actionBar}>
          <CustomizedDialogs 
            title="Nouveau produit" 
            boutonTitle="Ajouter un produit" 
            icon="product"
            refresh={refreshProduits}
          >
            <RegistrationForm />
          </CustomizedDialogs>
          
          <Box display="flex" alignItems="center" gap={2}>
            <input
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={importExcel}
              className={classes.fileInput}
              id="file-upload"
            />
            <label htmlFor="file-upload">
              <Button
                component="span"
                className={classes.fileUploadButton}
                startIcon={<CloudUpload />}
              >
                Importer Excel
              </Button>
            </label>
          </Box>
        </Box>

        {loading ? (
          <Box className={classes.loadingContainer}>
            <CircularProgress size={40} style={{ color: '#226D68' }} />
          </Box>
        ) : (
          <MaterialTable
            columns={produitColumns}
            data={prod}
            editable={{
              onRowAdd: (newRow) => new Promise((resolve) => {
                dispatch(addProduit(newRow));
                refreshProduits();
                setTimeout(resolve, 500);
              }),
              onRowDelete: (selectedRow) => new Promise((resolve) => {
                if (auth.rol === "admin") {
                  dispatch(deleteProduit(selectedRow.codeIdProd));
                  refreshProduits();
                } else {
                  toast.error("Vous n'avez pas les droits de suppression", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                  });
                }
                setTimeout(resolve, 1000);
              }),
              onRowUpdate: (newRow, oldRow) => new Promise((resolve, reject) => {
                ProduitService.updateProduit(newRow, oldRow.codeIdProd)
                  .then((response) => {
                    console.log("Produit modifié avec succès:", response);
                    toast.success("Produit modifié avec succès", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshProduits(); 
                    resolve();
                  })
                  .catch((error) => {
                    console.error("Erreur lors de la modification:", error);
                    toast.error(error.response?.data?.message || "Erreur lors de la modification", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    reject();
                  });
              })
            }}
            actions={[
              {
                icon: () => <ListAltOutlined style={{ color: '#226D68' }} />,
                tooltip: "Modifier le produit",
                onClick: (event, rowData) => {
                  if (auth?.rol === 'gerant') {
                    toast.error("Vous n'avez pas les droits de modification", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    return;
                  }
                  handleEditOpen(rowData);
                },
              },
              {
                icon: () => <AdjustIcon style={{ color: '#f26522' }} />,
                tooltip: "Ajuster le stock",
                onClick: (event, rowData) => {
                  if (auth?.rol === 'gerant') {
                    toast.error("Vous n'avez pas les droits de modification", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    return;
                  }
                  handleAjusterOpen(rowData);
                },
              }
            ]}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: "right",
              searchAutoFocus: true,
              searchFieldVariant: "outlined",
              filtering: true,
              paging: true,
              pageSizeOptions: [5, 10, 20, 50],
              pageSize: 10,
              paginationType: "stepped",
              showFirstLastPageButtons: true,
              exportButton: true,
              exportAllData: true,
              exportFileName: "Liste_des_produits",
              actionsColumnIndex: -1,
              rowStyle: (data, index) => index % 2 === 0 ? { background: "#f8f9fa" } : null,
              headerStyle: {
                background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                color: "#fff",
                fontSize: '14px',
                fontWeight: 600,
              },
            }}
            title="Gestion des Produits"
            localization={{
              body: {
                emptyDataSourceMessage: "Aucun produit à afficher",
                addTooltip: "Ajouter",
                deleteTooltip: "Supprimer",
                editTooltip: "Modifier",
              }
            }}
          />
        )}
      </>
    );
  };

  // Mettre à jour les composants des tabs
  tabsConfig[1].component = renderProduitsTab();

  // Préparer les données initiales pour le formulaire de modification
  const getInitialValuesForEdit = () => {
    if (!editingProduct) return null;

    return {
      nomProd: editingProduct.nomProd || '',
      prixProd: editingProduct.prixProd || '',
      intituleFam: editingProduct.intituleFam || '',
      fournisseur: editingProduct.idFournisseur || '',
      dateExpiration: editingProduct.dateExpiration || '',
      quantite: editingProduct.qtEntrer || '0',
      codeBarre: editingProduct.codeBarre || '',
      formepharmaceutique: editingProduct.FormFarmaceutik || '',
      tva: editingProduct.tva || '0',
      boites: editingProduct.boites || '',
      prixBoite: editingProduct.prixBoite || '',
      pieces: editingProduct.pieces || '',
      prix_unitaire: editingProduct.prix_unitaire || '',
      // Ajouter l'ID du produit pour la modification
      codeIdProd: editingProduct.codeIdProd
    };
  };

  return (
    <div className={classes.pageContainer}>
      <Container maxWidth="xl">
        {/* Titre centré exactement comme dans Clients */}
        <Typography variant="h3" className={classes.title}>
          Gestion des Produits
        </Typography>

        {/* Navigation par onglets - Même style que Clients */}
        <Paper elevation={0}>
          <AppBar position="static" className={classes.appBar}>
            <StyledTabs 
              value={value} 
              onChange={handleChange}
              className={classes.tabs}
              variant={isMobile ? "scrollable" : "standard"}
              scrollButtons="auto"
              centered
            >
              {visibleTabs.map((tab, index) => (
                <StyledTab
                  key={index}
                  icon={tab.icon}
                  label={isMobile ? null : tab.label}
                  aria-label={tab.label}
                />
              ))}
            </StyledTabs>
          </AppBar>

          {/* Contenu des onglets */}
          {visibleTabs.map((tab, index) => (
            <TabContainer key={index} value={value} index={index}>
              {tab.component}
            </TabContainer>
          ))}
        </Paper>

        {/* Indicateurs de statut en bas de page - Même style que Clients */}
        <Box mt={3} display="flex" justifyContent="center" flexWrap="wrap">
          <Chip
            icon={<Business style={{ color: '#226D68' }} />}
            label={`${stats.totalProducts} produits`}
            className={classes.chip}
            style={{ 
              backgroundColor: '#E8F5E8', 
              color: '#226D68',
              border: '1px solid #226D68'
            }}
          />
          <Chip
            icon={<AttachMoney style={{ color: '#f26522' }} />}
            label={`${stats.lowStock} stock faible`}
            className={classes.chip}
            style={{ 
              backgroundColor: '#FFF3E0', 
              color: '#f26522',
              border: '1px solid #f26522'
            }}
          />
          <Chip
            icon={<Edit style={{ color: '#dc3545' }} />}
            label={`${stats.expiredSoon} expirent bientôt`}
            className={classes.chip}
            style={{ 
              backgroundColor: '#FFEBEE', 
              color: '#dc3545',
              border: '1px solid #dc3545'
            }}
          />
        </Box>

        {/* Footer décoratif - Même style que Clients */}
        <Box mt={4} textAlign="center">
          <Typography variant="body2" color="textSecondary">
            Système de gestion des produits • 
            <span style={{ color: '#226D68', fontWeight: 600 }}> Vert</span>
            <span style={{ color: '#f26522', fontWeight: 600 }}> Orange</span>
            {' '}Theme
          </Typography>
        </Box>
      </Container>

      {/* Dialog de modification avec RegistrationForm */}
      <Dialog
        open={editDialogOpen}
        onClose={handleEditClose}
        maxWidth="md"
        fullWidth
        className={classes.editDialog}
      >
        <DialogContent className={classes.dialogContent}>
          {editingProduct && (
            <RegistrationForm 
              onClose={handleEditClose}
              refresh={handleProductUpdate}
              initialData={getInitialValuesForEdit()}
              isEditMode={true}
              productId={editingProduct.codeIdProd}
            />
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={ajustementDialogOpen}
        onClose={handleEditClose}
        maxWidth="md"
        fullWidth
        className={classes.editDialog}
      >
        <DialogContent className={classes.dialogContent}>
          {ajustementDialogOpen && (
            <AjusterStockDialog
              open={ajustementDialogOpen}
              onClose={handleAjusterClose}
              product={selectedProduct}
              onAjusterSuccess={handleAjusterSuccess}
              auth={auth}
          />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Produits;